import React from 'react';
import { Box, InputBase, Typography, useTheme } from '@mui/material';
import { cueLabelSx, getTokens, metaSx } from './aiAgentTheme';

/**
 * Jedna replika scenára na časovej osi hovoru: kedy zaznie (popisok pri osi)
 * a čo asistent povie (editovateľný riadok). Prázdne pole = vtedy mlčí.
 */
const AiCueField = ({ when, hint, value, placeholder, onChange, last = false }) => {
    const theme = useTheme();
    const tokens = getTokens(theme.palette.mode === 'dark', theme.palette.primary.main);
    const filled = !!(value || '').trim();

    return (
        <Box sx={{ display: 'flex', gap: 2, position: 'relative', pb: last ? 0 : 3 }}>
            {/* os hovoru */}
            <Box sx={{ position: 'relative', width: 10, flexShrink: 0 }}>
                <Box
                    sx={{
                        position: 'absolute',
                        left: 4,
                        top: 14,
                        bottom: last ? 'auto' : -12,
                        height: last ? 0 : 'auto',
                        width: '1px',
                        bgcolor: tokens.spine,
                    }}
                />
                <Box
                    sx={{
                        position: 'absolute',
                        left: 0,
                        top: 8,
                        width: 9,
                        height: 9,
                        borderRadius: '50%',
                        border: `1px solid ${filled ? tokens.accent : tokens.spine}`,
                        bgcolor: filled ? tokens.accent : 'transparent',
                    }}
                />
            </Box>

            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography component="div" sx={{ ...cueLabelSx(tokens), mb: 0.75 }}>
                    {when}
                </Typography>
                <InputBase
                    multiline
                    fullWidth
                    value={value || ''}
                    placeholder={placeholder}
                    onChange={onChange}
                    sx={{
                        p: 0,
                        fontSize: 15,
                        lineHeight: 1.55,
                        color: tokens.ink,
                        '& textarea': { p: 0 },
                        '& textarea::placeholder': { color: tokens.inkMuted, opacity: 1, fontStyle: 'italic' },
                        borderBottom: `1px solid ${tokens.hairline}`,
                        pb: 0.75,
                        transition: 'border-color .15s ease',
                        '&:hover': { borderBottomColor: tokens.spine },
                        '&.Mui-focused': { borderBottomColor: tokens.accent },
                    }}
                />
                {hint ? (
                    <Typography
                        sx={{ ...metaSx(tokens), mt: 0.75 }}
                    >
                        {hint}
                    </Typography>
                ) : null}
            </Box>
        </Box>
    );
};

export default AiCueField;
